import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

import { Small } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';
import { useTheme } from '@oui/app-core/src/styles';

function LevelBubble({ level, colors }: { colors: [string, string]; level: number }) {
  return (
    <View
      style={{
        width: 26,
        height: 26,
        borderRadius: 13,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <LinearGradient
        colors={colors}
        style={[StyleSheet.absoluteFillObject]}
        start={[0, 0]}
        end={[1, 0]}
      />
      <View
        style={{
          width: 22,
          height: 22,
          borderRadius: 11,
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <LinearGradient
          colors={colors}
          style={StyleSheet.absoluteFillObject}
          start={[0, 0]}
          end={[0, 1]}
        />
        <Small text={level.toString()} color="#B5831F" />
      </View>
    </View>
  );
}

/**
 * Indicates current level and progress towards next.
 */
export const LevelProgressBar = ({
  nextLevel,
  progress,
}: {
  nextLevel: number;
  progress: number;
}) => {
  const { theme } = useTheme();
  return (
    <View
      testID="LevelProgressBar"
      style={{
        flexDirection: 'row',
        backgroundColor: theme.color.accentThree300,
        height: 30,
        alignItems: 'center',
        borderRadius: 15,
      }}
    >
      <View
        style={{
          height: 30,
          borderRadius: 15,
          width: `${progress * 100}%`,
          minWidth: 30,
          backgroundColor: theme.color.accentThree100,
        }}
      />
      {nextLevel > 1 ? (
        <View
          style={{
            position: 'absolute',
            left: 2,
            top: 2,
          }}
        >
          <LevelBubble colors={['#FBE8C0', '#F8CF7F']} level={nextLevel - 1} />
        </View>
      ) : null}
      <View
        style={{
          position: 'absolute',
          right: 2,
          top: 2,
        }}
      >
        <LevelBubble colors={['#FFCE51', '#F3B14E']} level={nextLevel} />
      </View>
    </View>
  );
};
